import {
    createRouter,
    createWebHashHistory,
    createWebHistory
} from 'vue-router'
import store from '@/store'
import {
    getCurrentMenu
} from '@/api/system.js'
import {statisticsRevenue} from "@/api/statistics/advert";

const routes = [{
        path: "/",
        redirect: "/public"
    },
    {
        path: "/login",
        name: "login",
        component: () => import("../views/public/login.vue"),
    },
    {
        path: "/public",
        name: "public",
        component: () => import("../views/public/index.vue"),
        children: [{
                path: "/refresh",
                component: () => import("../views/public/refresh.vue"),
            },
            {
                path: 'system',
                redirect: '/system/user',
                children: [{
                        path: '/system/user',
                        meta: {
                            title: '用户管理',
                            name: 'system_user',
                            keepAlive: true
                        },
                        component: () => import('../views/system/user/userIndex.vue')
                    },
                    {
                        path: '/system/useradd',
                        meta: {
                            title: '新增用户',
                            name: 'system_user_add',
                            keepAlive: false
                        },
                        component: () => import('../views/system/user/userOp.vue')
                    },
                    {
                        path: '/system/usersave',
                        meta: {
                            title: '编辑用户',
                            name: 'system_user_edit',
                            keepAlive: false
                        },
                        component: () => import('../views/system/user/userOp.vue')
                    },
                    {
                        path: '/system/menu',
                        meta: {
                            title: '菜单管理',
                            name: 'system_menu',
                            keepAlive: true
                        },
                        component: () => import('../views/system/menu/menuIndex.vue')
                    },
                    {
                        path: '/system/menuadd',
                        meta: {
                            title: '新增菜单',
                            name: 'system_menu_add',
                            keepAlive: false
                        },
                        component: () => import('../views/system/menu/menuOp.vue')
                    },
                    {
                        path: '/system/menusave',
                        meta: {
                            title: '编辑菜单',
                            name: 'system_menu_save',
                            keepAlive: false
                        },
                        component: () => import('../views/system/menu/menuOp.vue')
                    },
                    {
                        path: '/system/role',
                        meta: {
                            title: '角色管理',
                            name: 'system_role',
                            keepAlive: true
                        },
                        component: () => import('../views/system/role/roleIndex.vue')
                    },
                    {
                        path: '/system/roleadd',
                        meta: {
                            title: '新增角色',
                            name: 'system_role_add',
                            keepAlive: false
                        },
                        component: () => import('../views/system/role/roleOp.vue')
                    },
                    {
                        path: '/system/rolesave',
                        meta: {
                            title: '编辑角色',
                            name: 'system_role_edit',
                            keepAlive: false
                        },
                        component: () => import('../views/system/role/roleOp.vue')
                    },
                    {
                        path: '/system/global',
                        meta: {
                            title: '全局设置',
                            name: 'system_global_setting',
                            keepAlive: true
                        },
                        component: () => import('../views/system/global/index.vue')
                    },
                    {
                        path: '/system/settings/sign',
                        meta: {
                            title: '签到规则配置',
                            name: 'ruleSignSettings',
                            keepAlive: true
                        },
                        component: () => import('../views/system/global/sign.vue')
                    },
                    {
                        path: '/system/settings/invitation',
                        meta: {
                            title: '邀请规则配置',
                            name: 'ruleInvitation',
                            keepAlive: true
                        },
                        component: () => import('../views/system/global/invitation.vue')
                    },
                    {
                        path: '/system/settings/benefits',
                        meta: {
                            title: '新人福利配置',
                            name: 'ruleNewcomerBenefits',
                            keepAlive: true
                        },
                        component: () => import('../views/system/global/benefits.vue')
                    },
                    {
                        path: '/system/settings',
                        meta: {
                            title: '规则文本配置',
                            name: 'ruleSettings',
                            keepAlive: true
                        },
                        component: () => import('../views/system/global/settings.vue')
                    }
                ]
            },
            {
                path: '/advertisement',
                redirect: '/advertisement/platform/index',
                children: [{
                    path: '/advertisement/platform/index',
                    meta: {
                        title: '广告平台',
                        name: 'advertisement_platform',
                        keepAlive: true
                    },
                    component: () => import('../views/advertisement/platform/index.vue')
                }, {
                    path: '/advertisement/customer/index',
                    meta: {
                        title: '广告客户',
                        name: 'advertisement_customer',
                        keepAlive: true
                    },
                    component: () => import('../views/advertisement/customer/index.vue')
                }, {
                    path: '/advertisement/channel/index',
                    meta: {
                        title: '渠道类别',
                        name: 'advertisement_channel',
                        keepAlive: true
                    },
                    component: () => import('../views/advertisement/channel/index.vue')
                }, {
                    path: '/advertisement/type/index',
                    meta: {
                        title: '广告类型',
                        name: 'advertisement_type',
                        keepAlive: true
                    },
                    component: () => import('../views/advertisement/type/index.vue')
                }, {
                    path: '/advertisement/autonomous/index',
                    meta: {
                        title: '自主资源',
                        name: 'advertisement_autonomous',
                        keepAlive: true
                    },
                    component: () => import('../views/advertisement/autonomous/index.vue')
                }]
            },
            {
                path: '/advertmanage',
                redirect: '/advertmanage/channel/index',
                children: [{
                        path: '/advertmanage/channel/index',
                        meta: {
                            title: '渠道管理',
                            name: 'advertmanage_channel',
                            keepAlive: true
                        },
                        component: () => import('../views/advertmanage/channel/index.vue')
                    }, {
                        path: '/advertmanage/project/index',
                        meta: {
                            title: '项目管理',
                            name: 'advertmanage_project',
                            keepAlive: true
                        },
                        component: () => import('../views/advertmanage/project/index.vue')
                    }, {
                        path: '/advertmanage/bit/index',
                        meta: {
                            title: '广告位',
                            name: 'advertmanage_bit',
                            keepAlive: true
                        },
                        component: () => import('../views/advertmanage/bit/index.vue')
                    }, {
                        path: '/advertmanage/bit/indexadd',
                        meta: {
                            title: '新增广告位',
                            name: 'advertmanage_bit_add',
                            keepAlive: false
                        },
                        component: () => import('../views/advertmanage/bit/indexOp.vue')
                    },
                    {
                        path: '/advertmanage/bit/indexedit',
                        meta: {
                            title: '编辑广告位',
                            name: 'advertmanage_bit_edit',
                            keepAlive: false
                        },
                        component: () => import('../views/advertmanage/bit/indexOp.vue')
                    },
                ]
            }, {
                path: 'weixin',
                redirect: '/weixin/index',
                children: [{
                    path: '/weixin/index',
                    meta: {
                        title: '小程序',
                        name: 'weixin_index',
                        keepAlive: true
                    },
                    component: () => import('../views/weixin/index.vue')
                }, ]
            }, {
                path: '/statistics',
                redirect: '/statistics/advert/index',
                children: [
                    {
                        path: '/statistics/advert/index',
                        meta: {
                            title: '广告数据',
                            name: 'dataStatisticsAdvert',
                            keepAlive: true
                        },
                        component: () => import('../views/statistics/advert.vue')
                    },
                    {
                        path: '/statistics/operatingCost/index',
                        meta: {
                            title: '运营日统计表',
                            name: 'statisticsOperatingCost',
                            keepAlive: true
                        },
                        component: () => import('../views/statistics/operatingCost.vue')
                    },
                    {
                        path: '/statistics/revenue/index',
                        meta: {
                            title: '营收日统计表',
                            name: 'statisticsRevenue',
                            keepAlive: true
                        },
                        component: () => import('../views/statistics/revenue.vue')
                    },
                    {
                        path: '/statistics/cashOutflow/index',
                        meta: {
                            title: '现金流出日统计表',
                            name: 'statisticsCashOutflow',
                            keepAlive: true
                        },
                        component: () => import('../views/statistics/cashOutflow.vue')
                    },
                    {
                        path: '/statistics/consumeCash/index',
                        meta: {
                            title: '用户消耗成本及现金统计表',
                            name: 'statisticsConsumeCash',
                            keepAlive: true
                        },
                        component: () => import('../views/statistics/consumeCash.vue')
                    },
                ]
            },
            {
                path: '/user',
                redirect: '/user/manage',
                children: [{
                    path: '/user/manage',
                    meta: {
                        title: '用户管理',
                        name: 'user_manage_index',
                        keepAlive: true
                    },
                    component: () => import('../views/user/index.vue')
                }, {
                    path: '/user/manage/info',
                    meta: {
                        title: '用户详情',
                    },
                    component: () => import('../views/user/info.vue')
                }, {
                    path: '/user/manage/points',
                    meta: {
                        title: '积分记录',
                        name: 'user_manage_points',
                        keepAlive: true
                    },
                    component: () => import('../views/user/points.vue')
                }, {
                    path: '/user/manage/withdrawalHistory',
                    meta: {
                        title: '提现记录',
                        name: 'withdrawalHistory',
                        keepAlive: true
                    },
                    component: () => import('../views/user/withdrawal.vue')
                }, ]
            }, {
                path: '/settlement/channel',
                meta: {
                    title: '渠道结算',
                    name: 'settlementChannel',
                    keepAlive: true
                },
                component: () => import('../views/settlement/channel.vue')
            }, {

                path: '/prize',
                redirect: '/prize/index',
                children: [{
                    path: '/prize/index',
                    meta: {
                        title: '奖品管理',
                        name: 'prizesManage',
                        keepAlive: true
                    },
                    component: () => import('../views/prize/index.vue')
                }]
            },
            {
                path: '/consulting',
                redirect: '/consulting/index',
                children: [{
                    path: '/consulting/index',
                    meta: {
                        title: '招商咨询记录',
                        name: 'consulting',
                        keepAlive: true
                    },
                    component: () => import('../views/consulting/index.vue')
                }]
            }
        ]
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

// 确保在内页时刷新页面导致vuex中存储的权限列表没了无法判断
router.beforeEach((to, form, next) => {
    document.title = '长鲲广告管理系统';

    if (to.path == '/login' || !localStorage.getItem('token')) {
        return next()
    }

    let menuList = store.state.menuList
    if (menuList.length < 1) {
        getCurrentMenu().then(res => {
            store.commit('setMenuList', res.list)
            store.commit('setOperation', res.operation)
            next()
        })
    } else {
        next()
    }
})

export default router